module.exports = __webpack_public_path__ + "static/media/autex.a45908fb.png";